import { Text } from "@clipboard-health/ui-components";
import { Stack, type StackProps } from "@mui/material";

interface FilterSectionWrapperProps extends StackProps {
  sectionTitle: string;
  sectionSubtitle?: string;
}

export function FilterSectionWrapper(props: FilterSectionWrapperProps) {
  const { children, sectionTitle, sectionSubtitle, ...restProps } = props;

  return (
    <Stack spacing={5} {...restProps}>
      {sectionSubtitle ? (
        <Stack spacing={2}>
          <Text semibold variant="body1">
            {sectionTitle}
          </Text>
          <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
            {sectionSubtitle}
          </Text>
        </Stack>
      ) : (
        <Text semibold variant="body1">
          {sectionTitle}
        </Text>
      )}

      {children}
    </Stack>
  );
}
